/* HOME PASSION · mikro etkilesimler
   NOT: ozel "SURUKLE" imleci kaldirildi (istenmedi).
   Kalan: miknatisli butonlar + hafif 3D egim + native surukleme engeli. */
(function(){
  'use strict';
  var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE=window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  /* --- Native link/gorsel suruklemesini engelle (karusel kilitleniyordu) --- */
  function killNativeDrag(root){
    (root||document).querySelectorAll('.hp-crsl-vp, .hp-vid-vp, .hp-vcat-vp').forEach(function(vp){
      if(vp.dataset.nodrag) return; vp.dataset.nodrag='1';
      vp.addEventListener('dragstart', function(e){ e.preventDefault(); });
      vp.querySelectorAll('a,img,video').forEach(function(el){ el.setAttribute('draggable','false'); });
    });
  }

  if(RM||!FINE){ 
    if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){killNativeDrag()}); }
    else { killNativeDrag(); }
    document.addEventListener('shopify:section:load',function(e){ killNativeDrag(e.target); });
    return; 
  }

  /* --- Miknatisli butonlar --- */
  function magnets(root){
    var sel='.hp .hp-btn, .hp .hp-vid-add, .hp .hp-li button, .hp .hp-dc-l';
    (root||document).querySelectorAll(sel).forEach(function(b){
      if(b.dataset.mag) return; b.dataset.mag='1';
      var R=64, S=0.3;
      b.addEventListener('pointerenter',function(){ b.classList.add('mag'); });
      b.addEventListener('pointermove',function(e){
        var r=b.getBoundingClientRect();
        var dx=e.clientX-(r.left+r.width/2), dy=e.clientY-(r.top+r.height/2);
        if(Math.hypot(dx,dy) > R+Math.max(r.width,r.height)/2) return;
        b.style.setProperty('--mx',(dx*S).toFixed(1)+'px');
        b.style.setProperty('--my',(dy*S*0.7).toFixed(1)+'px');
      });
      b.addEventListener('pointerleave',function(){
        b.classList.remove('mag');
        b.style.setProperty('--mx','0px'); b.style.setProperty('--my','0px');
      });
    });
  }

  /* --- Hafif 3D egim (surukleme sirasinda kapali) --- */
  function tilt(root){
    (root||document).querySelectorAll('.hp-vid, .hp-vcat').forEach(function(c){
      if(c.dataset.tilt) return; c.dataset.tilt='1';
      c.classList.add('hp-tilt');
      var MAX=4;
      c.addEventListener('pointerenter',function(){ c.classList.add('live','tilting'); });
      c.addEventListener('pointermove',function(e){
        var vp=c.closest('.hp-vid-vp,.hp-vcat-vp');
        if(vp && vp.classList.contains('drag')) return;
        var r=c.getBoundingClientRect();
        var px=(e.clientX-r.left)/r.width-0.5;
        var py=(e.clientY-r.top)/r.height-0.5;
        c.style.setProperty('--ry',(px*MAX*2).toFixed(2)+'deg');
        c.style.setProperty('--rx',(-py*MAX).toFixed(2)+'deg');
      });
      c.addEventListener('pointerleave',function(){
        c.classList.remove('live','tilting');
        c.style.setProperty('--rx','0deg'); c.style.setProperty('--ry','0deg');
      });
    });
  }

  function boot(root){ killNativeDrag(root); magnets(root); tilt(root); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){boot()}); }
  else { boot(); }
  document.addEventListener('shopify:section:load',function(e){ boot(e.target); });
})();
